import './mycateringconcierge2/style';
import FormStructure from './mycateringconcierge2/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/includes.js